import { useMemo } from "react";

import MarkdownIt from "markdown-it";
import xss from "xss";

import { cn } from "@/lib/utils";

interface MarkdownProps {
  content: string;
  className?: string;
}

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true
});

export function Markdown({ content, className }: MarkdownProps) {
  const htmlContent = useMemo(() => xss(md.render(content)), [content]);

  return (
    <div
      className={cn("markdown-it max-w-none", className)}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}
